import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { trackWorkingLead } from "@/lib/utils";
import draNataliaHero from "@/assets/dra-natalia-hero.png";

const Hero = () => {
  const whatsappUrl = "https://api.whatsapp.com/send?phone=+5511947854799&text=Vim%20pelo%20site%20e%20quero%20agendar%20minha%20consulta.";
  
  const handleWhatsAppClick = () => {
    trackWorkingLead();
  };
  return <section className="relative min-h-[100dvh] flex items-center justify-center overflow-hidden pt-20 sm:pt-24">
      {/* Background layers */}
      <div className="absolute inset-0 bg-gradient-to-br from-background via-secondary/30 to-background z-0" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,hsl(var(--primary)_/_0.05),transparent_70%)] z-0" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,hsl(var(--accent)_/_0.08),transparent_50%)] z-0" />
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-16 relative z-10">
        <div className="grid lg:grid-cols-2 gap-6 sm:gap-10 lg:gap-16 items-center">
          {/* Content Section */}
          <div className="space-y-4 sm:space-y-6 lg:space-y-8 text-center lg:text-left order-2 lg:order-1">
            <div className="space-y-3 sm:space-y-4 lg:space-y-5 animate-fade-in-up">
              {/* Badge Superior */}
              <div className="inline-flex items-center gap-2 sm:gap-2.5 px-3 sm:px-4 md:px-5 py-2 sm:py-2.5 rounded-full border border-primary/30 bg-primary/5 backdrop-blur-sm">
                <Sparkles className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-accent flex-shrink-0" />
                <span className="text-foreground font-inter text-[10px] sm:text-xs md:text-sm uppercase tracking-wider font-medium whitespace-nowrap">CRO-SP 132.903</span>
              </div>
              
              {/* Title */}
              <div className="space-y-2 sm:space-y-3">
                <h1 className="font-kiona text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-foreground leading-[0.95] tracking-tight">
                  Dra. Natália Piller
                </h1>
                <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-foreground/90 font-inter font-light">
                  Dentística Estética e Periodontia
                </p>
              </div>
            </div>

            {/* Description */}
            <div className="animate-fade-in-up" style={{
            animationDelay: '0.2s'
          }}>
              <p className="text-xs sm:text-sm md:text-base lg:text-lg text-muted-foreground leading-relaxed font-inter max-w-xl mx-auto lg:mx-0">
                Cada sorriso conta uma história única. Unimos estética dental, saúde gengival e harmonização facial 
                com atendimento acolhedor e técnicas atualizadas. Há <strong>7 anos</strong> criamos transformações naturais 
                que realçam a beleza e a saúde dos nossos pacientes.
              </p>
            </div>

            {/* CTA Button */}
            <div className="flex justify-center lg:justify-start animate-fade-in-up pt-1 sm:pt-2" style={{
            animationDelay: '0.4s'
          }}>
              <Button variant="whatsapp" size="lg" className="hover-lift text-xs sm:text-sm font-medium h-10 sm:h-12 px-5 sm:px-6 w-full sm:w-auto max-w-xs sm:max-w-none" asChild>
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" onClick={handleWhatsAppClick}>
                  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                  Agende sua Avaliação
                </a>
              </Button>
            </div>
          </div>

          {/* Image Section */}
          <div className="relative animate-fade-in-up order-1 lg:order-2" style={{
          animationDelay: '0.3s'
        }}>
            <div className="relative group max-w-md sm:max-w-lg mx-auto lg:max-w-xl">
              <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-accent/5 rounded-xl sm:rounded-2xl lg:rounded-3xl" />
              <div className="relative rounded-xl sm:rounded-2xl lg:rounded-3xl shadow-gold-lg overflow-hidden aspect-square transition-all duration-700 group-hover:scale-[1.02] group-hover:shadow-gold">
                <img 
                  src={draNataliaHero} 
                  alt="Dra. Natália Piller - Dentista Especialista em Dentística Estética e Periodontia" 
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <div className="absolute inset-0 rounded-xl sm:rounded-2xl lg:rounded-3xl ring-1 ring-primary/20 pointer-events-none" />
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Hero;